import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  anio:number;
  login = false;
  constructor(private router: Router, private location: Location) {

    this.anio=new Date().getFullYear();
    
   }

  ngOnInit(): void {

    this.router.events.subscribe(val => {
      if (location.pathname.substr(1,5) === 'admin') {
          this.login = true;
        }

   });
  }

}
